import { render, staticRenderFns } from "./paginationmin.vue?vue&type=template&id=7b02b499"
import script from "./paginationmin.vue?vue&type=script&lang=js"
export * from "./paginationmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports